const formatter = new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
});

export function formatPrice(value: number): string {
  return formatter.format(value);
}

export function shopifyImg(url: string, width: number): string {
  return `${url}${url.includes("?") ? "&" : "?"}width=${width}`;
}

export const colorSwatches: Record<string, string> = {
  Wit: "#F4F1EA",
  "Warm wit": "#EEE4D0",
  Beige: "#D8C6A6",
  Lichtblauw: "#AFC7D6",
  Rood: "#B3453B",
  Oranje: "#D57A3B",
  Zwart: "#1C1A17",
};
